import styled from 'styled-components';
import { localizePercentageValue } from 'utils/i18nHelpers';
import { getColorHighlight } from 'utils/colorHelpers';

import { MeterOptions } from './types';
import { CHART_SIZES } from '../types';
import { SIZE_STYLES } from './MeterSizes';

type SegmentProps = MeterOptions & {
  color: string;
  total: number;
  hasHighlight: boolean;
  selectedOptions?: MeterOptions[];
  $highlightColor?: string;
};

type MeterSegmentProps = SegmentProps & { size: CHART_SIZES; isFullWidth?: boolean };

const Segment = styled.div<SegmentProps>`
  background: ${({ color }) => color};
  height: 100%;
  width: 100%;

  &:hover {
    background: ${({ $highlightColor, hasHighlight }) => hasHighlight && $highlightColor};
  }
`;

const SegmentWrapper = styled.div<{ size: CHART_SIZES; isFullWidth: boolean; percentage: string }>`
  ${({ size }) => SIZE_STYLES[size]};
  background: #f3f4f5;
  width: ${({ isFullWidth, percentage }) => (isFullWidth ? '100%' : percentage)};
`;

export const DATA_TEST = {
  segment: 'meter-segment',
};

export const MeterSegment = ({
  size,
  value,
  total,
  color,
  name,
  hasHighlight,
  isFullWidth = false,
}: MeterSegmentProps) => {
  const localizedPercentageValue = localizePercentageValue((value / total) * 100);

  return (
    <SegmentWrapper size={size} isFullWidth={isFullWidth} percentage={localizedPercentageValue}>
      <Segment
        data-test={`${DATA_TEST.segment}-${name}`}
        name={name}
        value={value}
        total={total}
        color={color}
        $highlightColor={getColorHighlight(color)}
        hasHighlight={hasHighlight}
      />
    </SegmentWrapper>
  );
};
